<template>
  <modal :is-open="itemDescriptionModalIsOpen" :closeable="false">
    <div>
      {{ currentSelectedItem.displayName }}:
      {{ currentSelectedItem.description }}
    </div>

    <div v-if="currentSelectedItem.type === 2">
      <br>
      <div>
        <div style="font-weight: bold;text-decoration: underline;">Catch rate</div>
        {{ currentSelectedItem.catchRate }}
      </div>
    </div>

    <template #footer>
      <button
          type="button"
          class="btn btn-secondary"
          @click="itemDescriptionModalIsOpen = false"
      >
        {{ translation.general.cancel }}
      </button>
    </template>
  </modal>

  <modal :is-open="confirmationModalIsOpen" :closeable="false">
    <span
        v-html="
        translation.shop.purchaseConfirmationMessage(
          currentSelectedItem.displayName,
          amount,
          totalCosts
        )
      "
    ></span>
    <template #footer>
      <button
          type="button"
          class="btn btn-secondary"
          @click="
          amount = 1;
          confirmationModalIsOpen = false;
        "
      >
        {{ translation.general.cancel }}
      </button>
      <button
          type="button"
          class="btn btn-primary"
          @click="purchaseItem(currentSelectedItem.name, amount)"
          :disabled="amount <= 0"
      >
        {{ translation.shop.purchase }}
      </button>
    </template>
  </modal>

  <modal
      :is-open="
      chooseAmountModalIsOpen &&
      !confirmationModalIsOpen &&
      !itemDescriptionModalIsOpen
    "
      :closeable="false"
  >
    <div>
      <span
          v-html="
          translation.shop.howManyYouWantBuy(currentSelectedItem.displayName)
        "
      ></span>
    </div>

    <br/>
    <div style="position: absolute; right: 70px; top: 75px">
      <ItemEntryButton
          :id="1"
          :name="''"
          :sprite_name="currentSelectedItem.name"
          :amount="0"
          @click="itemPictureClicked(currentSelectedItem)"
      />
    </div>

    <div>
      {{ translation.shop.amount }}
      <span class="font-weight-bold">${{ currentSelectedItem.price }}</span> /
      each:
      <br/>
      <input
          type="number"
          v-model="amount"
          @keyup="calcTotalCosts(amount)"
          @change="calcTotalCosts(amount)"
          min="1"
          max="100"
          style="width: 40%"
          @input="limit_buy_amount()"
      />
    </div>

    <div style="margin-top: 8px;">
      <button @click="amount=5;calcTotalCosts(amount)"
              style="margin: 3px;border-color: #ff444b;width: 30px;border-radius: 4px;">5
      </button>
      <button @click="amount=10;calcTotalCosts(amount)"
              style="margin: 3px;border-color: #ff444b;width: 30px;border-radius: 4px;">10
      </button>
      <button @click="amount=20;calcTotalCosts(amount)"
              style="margin: 3px;border-color: #ff444b;width: 30px;border-radius: 4px;">20
      </button>
    </div>

    <br/>

    Total Costs: <span class="font-weight-bold">${{ totalCosts }}</span> <br/>
    Remaining Money:
    <span class="font-weight-bold">${{ cash - totalCosts }}</span>

    <template #footer>
      <button
          type="button"
          class="btn btn-secondary"
          @click="
          amount = 1;
          chooseAmountModalIsOpen = false;
        "
      >
        {{ translation.general.cancel }}
      </button>
      <button
          type="button"
          class="btn btn-primary"
          @click="confirmationModalIsOpen = true"
          :disabled="amount <= 0"
      >
        {{ translation.general.continue }}
      </button>
    </template>
  </modal>

  <br/>

  <div style="display: flex">
    <div style="width: 40%; margin: auto">
      <button
          @click="enterInventory()"
          class="back-to-inventory-button"
          :disabled="isBlocked"
      >
        Inventory
      </button>
    </div>

    <br/>

    <div style="width: 40%; margin: auto">
      <button
          @click="enterBattleCoinShop()"
          class="back-to-inventory-button"
          :disabled="isBlocked"
      >
        Battle Coin Shop
      </button>
    </div>
  </div>

  <div class="container">
    <h5 class="item-list__title">You have: ${{ cash }}</h5>
  </div>

  <div v-for="(item, i) in shopItems" :key="item">
    <div
        style="
        display: flex;
        height: 70px;
        border-radius: 15px;
        width: 90%;
        margin: auto;
      "
        :style="[
        i % 2 ? { backgroundColor: '#707070' } : { backgroundColor: '#494949' },
      ]"
    >
      <div style="margin-top: 7px">
        <div style="position: absolute; left: 10%; padding: 15px">
          <ItemEntryButton
              :id="1"
              :name="''"
              :sprite_name="item.name"
              :amount="0"
              @click="itemPictureClicked(item)"
          />
        </div>
      </div>

      <div style="width: 23%"></div>
      <div style="width: 20%; margin: auto; color: white">
        {{ item.displayName }}
      </div>
      <div style="width: 10%; color: white; margin: auto">
        ${{ item.price }}
      </div>

      <button
          class="purchase-button"
          @click="
          amount = 1;
          itemClicked(item);
        "
      >
        {{ translation.shop.purchase }}
      </button>
    </div>
    <br/>
  </div>
</template>

<script>
import {currentView} from "../../utils/globals";
import ItemList from "./ItemList";
import ItemEntryButton from "../../components/ItemEntryButton/ItemEntryButton";
import Modal from "@/components/Modal/Modal";
import {ref} from "@vue/reactivity";
import {translation} from "@/utils/translations";
import {
  startLoadingProcess,
  stopLoadingProcess,
} from "../../components/LoadingOverlay/loadingOverlayControl";
import axios from "axios";
import {backendUri} from "../../utils/settings";
import {handleUnknownError} from "../../utils/utilities";
import {onMounted} from "@vue/runtime-core";
import {
  blockButton,
  isBlocked,
  unblockButton,
} from "../../components/ButtonControl/ButtonControl";
import {showModalMsg} from "../../components/Modal/modalUtils";
import BattleItemShop from "./BattleItemShop";
import Cache from "../../cache";
import {useQueryClient} from 'vue-query';

export default {
  name: "ItemShop",
  components: {
    ItemEntryButton,
    Modal,
  },
  data() {
    return {
      amount: 1,
    };
  },
  methods: {
    limit_buy_amount: function () {
      console.log(Number.isInteger(this.amount));
      if (!Number.isInteger(this.amount)) {
        this.amount = 1;
      }

      if (this.amount <= 0) {
        this.amount = 1;
      } else if (this.amount > 100) {
        this.amount = 100;
      }
    },
  },
  setup() {
    const queryClient = useQueryClient()

    const shopItems = ref({});
    const itemDescriptionModalIsOpen = ref(false);
    const confirmationModalIsOpen = ref(false);
    const chooseAmountModalIsOpen = ref(false);
    const currentSelectedItem = ref({});

    const totalCosts = ref(0);
    const cash = ref([]);

    const calcTotalCosts = async (amount) => {
      totalCosts.value = currentSelectedItem.value.price * amount;
    };

    const itemClicked = async (item) => {
      currentSelectedItem.value = item;
      chooseAmountModalIsOpen.value = true;
      await calcTotalCosts(1);
    };
    const itemPictureClicked = async (item) => {
      currentSelectedItem.value = item;
      itemDescriptionModalIsOpen.value = true;
    };

    const enterInventory = async () => {
      blockButton();
      currentView.value = ItemList;
    };

    const enterBattleCoinShop = async () => {
      blockButton();
      currentView.value = BattleItemShop;
    };

    const purchaseItem = async (item_name, amount) => {
      if (amount <= 0) {
        showModalMsg(translation.shop.itemAmountLessThenZero);
        return;
      }

      chooseAmountModalIsOpen.value = false;
      confirmationModalIsOpen.value = false;

      await axios
          .post(backendUri + "api/game/ext/shop/purchase/", {
            item_name: item_name,
            amount: amount,
          })
          .then((resp) => {
            cash.value = resp.data.cash;
            showModalMsg(translation.shop.purchaseSuccessfully);
            Cache.Inventory.invalidatePokeUsable(queryClient);
          })
          .catch((error) => {
            if (error.response.data.error === 1) {
              showModalMsg(translation.shop.itemDoesNotExist);
            } else if (error.response.data.error === 50) {
              showModalMsg(translation.shop.itemAmountLessThenZero);
            } else if (error.response.data.error === 2) {
              showModalMsg(translation.shop.itemNotPurchasable);
            } else if (error.response.data.error === 3) {
              showModalMsg(translation.shop.notEnoughMoneyToBuy);
            } else {
              handleUnknownError(error);
            }
          });

    };

    const refreshView = async () => {
      startLoadingProcess();
      try {
        const response = await Cache.Shop.getShop(queryClient);

        shopItems.value = response.data.shopItems;
        cash.value = response.data.cash;
      } catch (error) {
        handleUnknownError(error);
      }

      stopLoadingProcess();
    };

    onMounted(() => {
      refreshView();
      setTimeout(function () {
        unblockButton();
      }, 3000);
    });

    return {
      enterInventory,
      currentSelectedItem,
      chooseAmountModalIsOpen,
      translation,
      itemClicked,
      calcTotalCosts,
      totalCosts,
      confirmationModalIsOpen,
      itemDescriptionModalIsOpen,
      itemPictureClicked,
      refreshView,
      shopItems,
      purchaseItem,
      isBlocked,
      cash,
      enterBattleCoinShop,
    };
  },
};
</script>

<style lang="scss">
.back-to-inventory-button {
  width: 100%;
  margin: auto;
  border-radius: 55px;
  background-color: #007bff;
  border-color: black;
  color: white;

  &:disabled {
    opacity: 0.2;
  }

  &:hover {
    transform: scale(1.1);
  }
}

.purchase-button {
  width: 30%;
  height: 30px;
  margin: auto;
  border-radius: 55px;
  border: none;

  &:hover {
    transform: scale(1.1);
  }
}

.item-list {
  &__title {
    padding-top: 20px;
    margin-left: 8px;
  }

  &__entry {
    padding: 0;
    margin-bottom: 20px;
  }
}
</style>
